import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { LandingComponent } from './components/pages/landing/landing.component';
import { LoginComponent } from './components/pages/login/login.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
// import { RegisterComponent } from './components/pages/register/register.component';
import { ReliefsComponent } from './components/pages/reliefs/reliefs.component';
import { ThankyouComponent } from './components/pages/thankyou/thankyou.component';
import { PrivacyPolicyComponent } from './components/shared/privacy-policy/privacy-policy.component';
import { CanLandingGuard } from './guards/can-landing.guard';
import { CanLoginGuard } from './guards/can-login.guard';
import { CanLogOutGuard } from './guards/can-logout.guard';

const routes: Routes = [
  { path: '', component: HomeComponent,pathMatch: 'full', canActivate: [CanLandingGuard]},
  { path: 'home', component: HomeComponent, canActivate: [CanLoginGuard] },
  { path: 'login', component: LoginComponent, canActivate: [CanLogOutGuard] },
  { path: 'thankyou', component: ThankyouComponent},
  // { path: 'register', component: RegisterComponent},
  { path: 'landing', component: LandingComponent, canActivate: [CanLogOutGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [CanLoginGuard]  },
  { path: 'relief', component: ReliefsComponent, canActivate: [CanLoginGuard] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'editor', loadChildren: () => import('./components/pages/editor/editor.module').then(m => m.EditorModule) },
  { path: 'admin', loadChildren: () => import('./components/pages/admin/admin.module').then(m => m.AdminModule)},
  { path: '**', redirectTo: 'home', pathMatch: 'full'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
